import styled, { css } from 'styled-components';
import { colors, media } from 'tsx/theme';

export const RadioVerdigris = styled.input.attrs((p) => {
  return { ...p, type: 'radio' };
})`
  min-width: 24px;
  min-height: 24px;
  accent-color: ${colors.colorVerdigris} !important;
  cursor: pointer;

  ${media.md(css`
    min-width: 20px;
    min-height: 20px;
  `)};
`;
